import React, { useEffect, useState } from "react";
import './Navbar.css';
import { useDispatch } from "react-redux";
import { getDefaultSettings } from "../Redux/actions/defaultSettingsActions";
import "../Pages/ProjectV2/Project_Navbar/Navbar_1.css";
import DashSetting from "../Pages/Setting/DashSetting";
import { scrollxLogo, user_2 } from "../assets/icons/index";
import { Link } from "react-router-dom";

export default function NavBar() {
  const dispatch = useDispatch();
  const [isSettingOpen, setIsSettingOpen] = useState(false);

  useEffect(() => {
    fetchProjectSettings();
  }, []);

  const fetchProjectSettings = () => {
    dispatch(getDefaultSettings());
  };

  return (
    <nav className="w-full Pro_navbarDash h-[64px] flex flex-wrap items-center justify-between text-slate-200 focus:text-sly-700 drop-shadow-2xl">

      <div className="w-full h-full flex flex-wrap items-center justify-between px-[5%]">

        <div className="w-[15%] flex justify-start items-center">
          <img className="w-[18%] h-[18%]" src={scrollxLogo} />
          <span className="Syne text-xl font-light tracking-wide ">ScrollX.io</span> 
        </div>

        <div className="w-[15%] flex justify-center items-center">
          <h1 className="FontFamily-Avenir-reg text-[15px]  tracking-widest uppercase">Dashboard</h1>
        </div>

        <div className="w-[15%] flex justify-end items-center">
        <div className="mr-[30px] FontFamily-Avenir-reg text-[15px] tracking-widest uppercase">
              <Link to="/dashboard/myrenders">
                <h2>My Renders </h2>
              </Link>
            </div>
          <button onClick={() => setIsSettingOpen(true)}><img className="opacity-75" src={user_2} style={{ width: "25px" }} /></button>
          </div>
      </div>
      
      <DashSetting isSettingOpen={isSettingOpen} setIsSettingOpen={setIsSettingOpen}/>
    </nav>
  );
}